import React from "react";
import { IconButton, IconButtonProps } from "@mui/material";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

// The round delete button for grid-like contexts: a red disc with a white trash icon. The round
// counterpart of ActionIconButton. For a delete outside a grid, use the text DeleteButton instead.
const DeleteIconButton = ({ sx, ...props }: IconButtonProps) => (
  <IconButton
    size="small"
    sx={{
      bgcolor: "error.main",
      color: "common.white",
      boxShadow: 2,
      "&:hover": { bgcolor: "error.dark", boxShadow: 4 },
      ...sx,
    }}
    {...props}
  >
    <DeleteOutlinedIcon fontSize="small" />
  </IconButton>
);

export default DeleteIconButton;
